interface Props {
    children: React.ReactNode;
}

const GroupedFields = ({ children }: Props) => (
    <div className="diary-summary-field-row flex w-full flex-col gap-x-4 gap-y-4 md:flex-row [&>*]:min-w-0 [&>*]:flex-1">
        {children}
    </div>
);
export default GroupedFields;
